"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spreadsheets = exports.reports = exports.forms = void 0;
exports.forms = require("./forms");
exports.reports = require("./reports");
exports.spreadsheets = require("./spreadsheets");
//# sourceMappingURL=index.js.map